export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      outerWidth: window.outerWidth,
      resizeTimer: null,
    }
  },
  created() {
    this.checkAndRedirect()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        this.windowWidth = window.innerWidth
        this.checkAndRedirect()
      }, 150)
    },
    // checkAndRedirect() {
    //     if (this.windowWidth < 768 || this.outerWidth < 768) {

    //         const hash = window.location.hash;   // 比如 /product
    //         const path = hash.split('?')[0];   // "#/details"
    //         const query = hash.split('?')[1] || '';

    //         let h5Path = '';
    //         console.log(window.location, 123)
    //         // 匹配 PC 页面路径，映射到对应 H5 页面路径
    //         if (hash.includes('/list')) {
    //             h5Path = 'pages/category/category';
    //         } else if (hash.includes('/details')) {
    //             h5Path = 'pages/goods/goods';
    //         } else if (hash.includes('/login')) {
    //             h5Path = 'pages/login/index';
    //         } else if (hash.includes('/designates')) {
    //             h5Path = 'pages/register/index';
    //         } else if (hash.includes('/mine')) {
    //             h5Path = 'pages/mine/mine';
    //         } else if (hash.includes('/car')) {
    //             h5Path = 'pages/cart/cart';
    //         } else if (hash.includes('/order_item')) {
    //             h5Path = 'pages/order/detail';
    //         } else {
    //             h5Path = '';
    //         }

    //         const h5Url = query
    //             ? `https://www.1-metals.com/h5/#/${h5Path}?${query}`
    //             : `https://www.1-metals.com/h5/#/${h5Path}`;

    //         // 跳转
    //         window.location.href = h5Url;
    //     }
    // }
    checkAndRedirect() {
      if (this.windowWidth < 768 || this.outerWidth < 768) {
        const { pathname, search, hash } = window.location

        // 统一取 query
        const query = search ? search.substring(1) : hash.split('?')[1] || ''

        let h5Path = ''

        // 根据 PC 路径匹配 H5 页面
        if (pathname.includes('/list')) {
          h5Path = 'pages/category/category'
        } else if (pathname.includes('/details')) {
          h5Path = 'pages/goods/goods'
        } else if (pathname.includes('/login')) {
          h5Path = 'pages/login/index'
        } else if (pathname.includes('/designates')) {
          h5Path = 'pages/register/index'
        } else if (pathname.includes('/mine')) {
          h5Path = 'pages/mine/mine'
        } else if (pathname.includes('/car')) {
          h5Path = 'pages/cart/cart'
        } else if (pathname.includes('/order_item')) {
          h5Path = 'pages/order/detail'
        }

        // 如果匹配到 H5 页面才跳转
        if (h5Path) {
          const h5Url = query
            ? `https://www.1-metals.com/h5/#/${h5Path}?${query}`
            : `https://www.1-metals.com/h5/#/${h5Path}`

          window.location.href = h5Url
        }
      }
    },
  },
}
